import { Link } from "react-router-dom";

function stripHtml(html) {
  const d = document.createElement("div");
  d.innerHTML = html || "";
  return (d.textContent || "").trim();
}

function excerpt(poem, n = 150) {
  const t = poem.body_html ? stripHtml(poem.body_html) : (poem.text || "").trim();
  return t.length > n ? t.slice(0, n).trimEnd() + "…" : t;
}

function fmtDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("de-CH", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
}

export default function PoemCard({ poem }) {
  return (
    <Link
      to={`/gedichte/${poem.slug}`}
      data-testid={`poem-card-${poem.slug}`}
      className="group block bg-[#3C1A5C] rounded-md p-6 sm:p-7 mb-5 ring-1 ring-[#632A8E]/50 hover:ring-[#F4C542]/50 transition-all"
    >
      <div className="flex items-baseline justify-between gap-4">
        <h3 className="font-serif text-3xl leading-tight text-[#FFF9F2] group-hover:text-[#F4C542] transition-colors">{poem.title}</h3>
      </div>
      <div className="mt-2 flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-[#F4C542]">
        <span>{fmtDate(poem.date)}</span>
        {poem.category && <span className="text-[#D85CA4]">· {poem.category}</span>}
      </div>
      <p className="mt-4 poem-body text-lg text-[#D8B9EA] leading-relaxed line-clamp-3">{excerpt(poem)}</p>
      <span className="mt-4 inline-block text-sm text-[#F4C542] border-b border-[#F4C542] pb-0.5">Weiterlesen</span>
    </Link>
  );
}

export { excerpt, fmtDate };
